import React from 'react';
import { connect } from 'react-redux';
import PageHeaderWrapper from '../../../components/PageHeaderWrapper';
import { Card, Tooltip, Button, Drawer, Col, DatePicker, Icon } from 'antd';
import Request from '../../../request';
import { TableComp } from 'sz-react-utils';
import { Row } from 'antd/es/grid';
import moment from 'moment';
import { RightsWrapper } from '../../../components/_utils/utils';
import _ from 'lodash';
const { RangePicker } = DatePicker
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
class FinanceWalletStudentDetails extends React.Component {
    state = {
        visible: true,
        count: 0,
        exportParams: {},
        viewByBranch: false,
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    exportExcel = async () => {
        let params = this.state.exportParams
        let x = await Request.exportFinanceWalletStudents(params);
        if (!x.error) {
            window.open(x.url)
        }
    }

    apiRequest = async (params) => {
        return new Promise(async (resolve) => {
            let { id, name, type, currency, paymentStatus, time } = this.props;
            params.id = id;
            params.type = type;
            params.currency = currency;
            params.paymentStatus = paymentStatus;
            if (time) {
                params.time = time;
            }
            this.setState({ exportParams: params });
            let response = await Request.getFinanceWalletStudentReport(params);
            this.setState({ count: response.total, viewByBranch: response.viewByBranch });
            resolve(response)
        })
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 500)
    }

    render() {
        let { visible, count, viewByBranch } = this.state;
        let { year, month } = this.props;
        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };
        let columns = [
            {
                title: 'Sr No.',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: 'VID',
                key: 'vid',
                searchTextName: 'vid',
            },
            {
                title: 'Student Name',
                key: 'studentName',
                searchTextName: 'Student Name',
            },
            {
                title: 'DOB',
                key: 'dateOfBirth',
                searchTextName: `${dateFormat}`,
                render: (text, record) => (
                    <div>{record && record.studentDetails && record.studentDetails.dateOfBirth ? moment(record.studentDetails.dateOfBirth).format(dateFormat) : "NA"}</div>
                )
            },
            {
                title: 'Passport Number',
                key: 'passportNumber',
                searchTextName: `Passort Number`,
                render: (text, record) => (
                    <div>{text ? text : record && record.studentDetails && record.studentDetails.visaDesk && record.studentDetails.visaDesk.passportNo ? record.studentDetails.visaDesk.passportNo : "NA"}</div>
                )
            },
            {
                title: 'Peforma Invoice Number',
                key: 'invoiceNumber',
                searchTextName: "Invoice Number",
                render: (text, record) => (
                    <div>{record.invoiceNumber ? record.invoiceNumber : "NA"}</div>
                )
            },
            {
                title: 'Term',
                key: 'termNumber',
                searchTextName: "Term Number",
                render: (text, record) => (
                    <div>{record.termNumber ? record.termNumber : "NA"}</div>
                )
            },
            {
                title: 'University',
                key: 'universityId.universityInstitutionName',
                hidden: this.props.isDirect,
                render: (text, record) => (
                    <div>
                        <div>{record && record.studentDetails && record.studentDetails.visaDesk && record.studentDetails.visaDesk.selectedCourse && record.studentDetails.visaDesk.selectedCourse.universityInstitutionName ? record.studentDetails.visaDesk.selectedCourse.universityInstitutionName : ""}</div>
                        {
                            !viewByBranch && record && record.studentDetails && record.studentDetails.visaDesk && record.studentDetails.visaDesk.selectedCourse && record.studentDetails.visaDesk.selectedCourse.channelPartnerName ?
                                <small style={{ background: 'red', color: '#fff', padding: '1px' }}>{record.studentDetails.visaDesk.selectedCourse.channelPartnerName}</small>
                                : ""
                        }
                    </div>
                )
            },
            {
                title: 'Amount',
                key: 'invoiceAmount',
                searchTextName: 'Amount',
                render: (text, record) => {
                    // fallback to INR if record.currency is missing or not found
                    const symbol = currencySymbols[record.currency] || currencySymbols["INR"] || "";
                    return (
                        <div>
                            {symbol}{record.invoiceAmount ? Number(record.invoiceAmount).toFixed(2) : "NA"}
                        </div>
                    );
                }
            },
            {
                title: 'Currency',
                key: 'currency',
                render: (text, record) => (
                    <div>{record.currency ? record.currency : "NA"}</div>
                )
            },
            {
                title: 'Due Date',
                key: 'invoiceDueDate',
                render: (text, record) => (
                    <div>{record && record.invoiceDueDate ? moment(record.invoiceDueDate).format(dateFormat) : "N/A"}</div>
                )
            },
            {
                title: 'Status',
                key: 'status',
                render: (text, record) => (
                    <div>{record.status ? record.status : "NA"}</div>
                )
            },

        ]


        if (this.props.isDirect) {
            columns = columns.filter(col => col.key !== "universityId.universityInstitutionName");
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Student Details :- {count} ({this.props.name})
                            {" "}
                            <RightsWrapper myRight={"financeWalletReportExport.view"} />
                        </React.Fragment>
                    </div>
                }

                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1200}
                visible={visible}>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest} />
                </Card>
            </Drawer>
        )
    }
}



class FinanceWalletReport extends React.Component {

    state = {
        formattedData: [],
        showStudentDetailDrawer: false,
        currency: null,
        status: null,
        time: null,
        exportParams: {},
        showCurrencyDetail: false,
        year: null,
        showYearDetail: false,
        month: null,
        showMonthDetail: false,
        universityId: null,
        showInstitutionTable: false,
        paymentStatus: null,
        term: null,
        isDirect: null,
        universityName: null,
        id: null,
        type: null,
        name: null,
        conversionRates: {},
        paymentResults: [],
        viewByBranch: false
    }

    showInstitutionDetails = (paymentStatus, currency) => {
        this.setState({ showInstitutionTable: true, paymentStatus, currency }, () => {
            this.institutionTable.current.reload();
        })
    }


    constructor(props) {
        super(props);
        this.table = React.createRef();
        this.table1 = React.createRef();
        this.table2 = React.createRef();
        this.table3 = React.createRef();
        this.institutionTable = React.createRef();
    }

    // loadFinanceReport = async () => {
    //     let response = await Request.getFinanceWalletReport();
    // }

    apiRequest = async (params) => {
        return new Promise(async (resolve) => {
            if (this.state.time) {
                params.time = this.state.time;
            }
            this.setState({ exportParams: params })
            let response = await Request.getFinanceWalletReport(params);
            this.setState({ paymentResults: response.data, viewByBranch: response.viewByBranch });
            resolve(response)
        })
    }

    apiCurrencyDetailRequest = async (params) => {
        return new Promise(async (resolve) => {
            if (this.state.currency) {
                params.currency = this.state.currency;
            }
            let response = await Request.apiCurrencyDetailRequest(params);
            // let response = await Request.getFinanceWalletReport(params);
            resolve(response)
        })
    }

    apiYearDetailRequest = async (params) => {
        return new Promise(async (resolve) => {
            if (this.state.currency) {
                params.currency = this.state.currency;
            }
            if (this.state.year) {
                params.year = this.state.year;
            }
            let response = await Request.apiYearDetailRequest(params);
            resolve(response)
        })
    }


    apiMonthDetailRequest = async (params) => {
        return new Promise(async (resolve) => {
            if (this.state.currency) {
                params.currency = this.state.currency;
            }
            if (this.state.year) {
                params.year = this.state.year;
            }
            if (this.state.month) {
                params.month = this.state.month;
            }
            let response = await Request.apiMonthDetailRequest(params);
            resolve(response)
        })
    }


    loadCountries = async () => {
        let { data } = await Request.getCountriesWithoutAuth({ results: 100, count: 100, businessId: activeUser && activeUser.businessId });
        let conversionRates = {};
        _.each(data, (country) => {
            if (country && country.currencyName) {
                conversionRates[country.currencyName] = country && country.currencyRate ? country.currencyRate : 0;
            }
        })
        this.setState({ conversionRates });
    }



    componentDidMount() {
        this.loadCountries()
    }


    showStudentDetails = async (id, type, name) => {
        this.setState({
            showStudentDetailDrawer: true,
            id,
            name,
            type
        })
    };


    closeStudentDetail = () => {
        this.setState({ showStudentDetailDrawer: false }, () => {
            this.institutionTable.current.reload();
        })
    }

    getDetailByCurrency = (currency) => {
        this.setState({ currency, showCurrencyDetail: true }, () => {
            this.table1.current.reload();
        })
    }


    getDetailsByYear = (year) => {
        this.setState({ year, showYearDetail: true }, () => {
            this.table2.current.reload();
        })
    }

    getDetailsByMonth = (month) => {
        this.setState({ month, showMonthDetail: true }, () => {
            this.table3.current.reload();
        })
    }

    chooseRangerPicker = (date, dateString) => {
        var time = null;

        if (date && date.length === 2) {
            time = {
                from: date[0],
                to: date[1],
            };
        }

        this.setState(
            {
                time: time,
            },
            () => {
                if (this.table && this.table.current) {
                    this.table.current.reload();
                }
            }
        );
    };

    onOk = (value) => {
        this.table.current.reload();
    };


    exportExcel = async () => {
        let params = this.state.exportParams
        let x = await Request.exportFinanceWalletReport(params);
        if (!x.error) {
            window.open(x.url)
        }
    }


    apiShowInstituteTable = async (params) => {
        return new Promise(async (resolve) => {
            if (this.state.paymentStatus) {
                params.paymentStatus = this.state.paymentStatus;
            }
            if (this.state.currency) {
                params.currency = this.state.currency;
            }

            if (this.state.time) {
                params.time = this.state.time;
            }

            let response = await Request.getFinanceReportByInstitution(params);
            resolve(response);
        })


    }

    render() {
        let { currency, status, showStudentDetailDrawer, universityId, showMonthDetail, showCurrencyDetail, year, showYearDetail, month, conversionRates, paymentResults, viewByBranch } = this.state

        let totalAmount = 0;
        let totalLiability = 0;

        paymentResults.forEach((record) => {
            let conversionRate = conversionRates[record.currency] || 0;

            // ✅ Outstanding
            let convertedAmount =
                parseFloat(record.outstanding || 0) * parseFloat(conversionRate);

            totalAmount += convertedAmount;

            // ✅ Liability
            let convertedLiability =
                parseFloat(record.liability || 0) * parseFloat(conversionRate);

            totalLiability += convertedLiability;
        });
        let netAmount = (totalAmount - totalLiability);
        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };
        const columns = [
            {
                title: "Currency",
                dataIndex: "currency",
                key: "currency",
                searchTextName: "Currency",
                // width: "33.3%",
                render: (text, record) => (
                    <div>{record.currency}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small">{record.currency}</Button>
                    // </Tooltip>
                ),
            },
            {
                title: "Total Outstanding",
                dataIndex: "outstanding",
                key: "outstanding",
                // width: "33.3%",
                render: (text, record) => (
                    <Tooltip title="Show Details">
                        <Button
                            size="small"
                            onClick={() =>
                                this.showInstitutionDetails("outstanding", record.currency)
                            }
                        >
                            <span dir='ltr'>
                                {currencySymbols[record.currency]}{record.outstanding ? record.outstanding.toFixed(2) : 0}
                            </span>
                        </Button>
                    </Tooltip>
                ),
            },
            {
                title: `Conversion Rate (Projected)`,
                dataIndex: 'conversionRate',
                key: 'conversionRate',
                // width: "10%",
                render: (text, record) => {
                    let conversionRate = conversionRates[record.currency] ? conversionRates[record.currency] : 0;
                    return (
                        <div>{currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}{conversionRate}</div>
                    )
                }
            },
            {
                title: 'Converted Amount (Projected)',
                dataIndex: 'convertedAmount',
                key: 'convertedAmount',
                render: (text, record) => {
                    let conversionRate = conversionRates[record.currency] ? conversionRates[record.currency] : 0;
                    let convertedAmount = parseFloat(record.outstanding) * parseFloat(conversionRate);
                    return (
                        <div>{currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}{convertedAmount.toFixed(2)}</div>
                    )
                }
            }
            // {
            //     title: "Amount Received",
            //     dataIndex: "received",
            //     key: "received",
            //     width: "33.3%",
            //     render: (text, record) => (
            //         <Tooltip title="Show Details">
            //             <Button
            //                 size="small"
            //                 onClick={() => this.showInstitutionDetails("received", record.currency)}
            //             >
            //                 {record.received ? record.received.toFixed(2) : 0}
            //             </Button>
            //         </Tooltip>
            //     ),
            // },
        ];

        const currencyDetailColumns = [
            {
                title: "Year",
                dataIndex: "year",
                key: "year",
                // searchTextName: 'Currency',
                render: (text, record) => (
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.getDetailsByYear(record.year)}>{record.year}</Button>
                    </Tooltip>
                )
            },
            {
                title: "Earned",
                dataIndex: "total",
                key: "total",
                render: (text, record) => (
                    <div>{record.total ? record.total.toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small" /* onClick={() => this.showStudentDetails(record.currency, null)}*/>{record.total ? record.total.toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: "To Be Invoiced",
                dataIndex: "Pending",
                key: "Pending",
                render: (text, record) => (
                    <div>{record.Pending ? record.Pending.toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small" /* onClick={() => this.showStudentDetails(record.currency, 'Pending')}*/>{record.Pending ? record.Pending.toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: 'Invoiced',
                dataIndex: 'Invoiced',
                key: 'invoiced',
                render: (text, record) => (
                    <div>{(
                        (record.Invoiced ? Number(record.Invoiced.toFixed(2)) : 0) +
                        (record.Disbursed ? Number(record.Disbursed.toFixed(2)) : 0) +
                        (record['Under Review'] ? Number(record['Under Review'].toFixed(2)) : 0) +
                        (record['Bad Debts'] ? Number(record['Bad Debts'].toFixed(2)) : 0)
                    ).toFixed(2)}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"  /* onClick={() => this.showStudentDetails(record.currency, 'Invoiced')}*/>
                    //         {(
                    //             (record.Invoiced ? Number(record.Invoiced.toFixed(2)) : 0) +
                    //             (record.Disbursed ? Number(record.Disbursed.toFixed(2)) : 0) +
                    //             (record['Under Review'] ? Number(record['Under Review'].toFixed(2)) : 0) +
                    //             (record['Bad Debts'] ? Number(record['Bad Debts'].toFixed(2)) : 0)
                    //         ).toFixed(2)}
                    //     </Button>

                    // </Tooltip>
                )
            },
            {
                title: 'Received',
                dataIndex: 'Disbursed',
                key: 'Disbursed',
                render: (text, record) => (
                    <div>{record['Disbursed'] ? record['Disbursed'].toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small" /* onClick={() => this.showStudentDetails(record.currency, "Disbursed")}*/>{record['Disbursed'] ? record['Disbursed'].toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: 'Outstanding',
                dataIndex: 'Under Review',
                key: 'Under Review',
                render: (text, record) => (
                    <div>{record['Under Review'] ? record['Under Review'].toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"  /* onClick={() => this.showStudentDetails(record.currency, "Under Review")} */>{record['Under Review'] ? record['Under Review'].toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: 'Withdrawals',
                dataIndex: 'Bad Debts',
                key: 'Bad Debts',
                render: (text, record) => (
                    <div>{record['Bad Debts'] ? record['Bad Debts'].toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small" /* onClick={() => this.showStudentDetails(record.currency, "Bad Debts")}*/>{record['Bad Debts'] ? record['Bad Debts'].toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },

        ];
        const yearDetailColumns = [
            {
                title: "Month",
                dataIndex: "month",
                key: "month",
                // searchTextName: 'Currency',
                render: (text, record) => (
                    // <div>{record.month}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.getDetailsByMonth(record.month)}>{record.month} - {this.state.year}</Button>
                    </Tooltip>
                )
            },
            {
                title: "Earned",
                dataIndex: "total",
                key: "total",
                render: (text, record) => (
                    <div>{record.total ? record.total.toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"  onClick={() => this.showStudentDetails(record.month, null)}>{record.total ? record.total.toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: "To Be Invoiced",
                dataIndex: "Pending",
                key: "Pending",
                render: (text, record) => (
                    <div>{record.Pending ? record.Pending.toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"  onClick={() => this.showStudentDetails(record.month, 'Pending')}>{record.Pending ? record.Pending.toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: 'Invoiced',
                dataIndex: 'Invoiced',
                key: 'invoiced',
                render: (text, record) => (
                    <div>{(
                        (record.Invoiced ? Number(record.Invoiced.toFixed(2)) : 0) +
                        (record.Disbursed ? Number(record.Disbursed.toFixed(2)) : 0) +
                        (record['Under Review'] ? Number(record['Under Review'].toFixed(2)) : 0) +
                        (record['Bad Debts'] ? Number(record['Bad Debts'].toFixed(2)) : 0)
                    ).toFixed(2)}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small" onClick={() => this.showStudentDetails(record.month, 'Invoiced')}>
                    //         {(
                    //             (record.Invoiced ? Number(record.Invoiced.toFixed(2)) : 0) +
                    //             (record.Disbursed ? Number(record.Disbursed.toFixed(2)) : 0) +
                    //             (record['Under Review'] ? Number(record['Under Review'].toFixed(2)) : 0) +
                    //             (record['Bad Debts'] ? Number(record['Bad Debts'].toFixed(2)) : 0)
                    //         ).toFixed(2)}
                    //     </Button>

                    // </Tooltip>
                )
            },
            {
                title: 'Received',
                dataIndex: 'Disbursed',
                key: 'Disbursed',
                render: (text, record) => (
                    <div>{record['Disbursed'] ? record['Disbursed'].toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"  onClick={() => this.showStudentDetails(record.month, "Disbursed")}>{record['Disbursed'] ? record['Disbursed'].toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: 'Outstanding',
                dataIndex: 'Under Review',
                key: 'Under Review',
                render: (text, record) => (
                    <div>{record['Under Review'] ? record['Under Review'].toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"   onClick={() => this.showStudentDetails(record.month, "Under Review")} >{record['Under Review'] ? record['Under Review'].toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },
            {
                title: 'Withdrawals',
                dataIndex: 'Bad Debts',
                key: 'Bad Debts',
                render: (text, record) => (
                    <div>{record['Bad Debts'] ? record['Bad Debts'].toFixed(2) : 0}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small"  onClick={() => this.showStudentDetails(record.month, "Bad Debts")}>{record['Bad Debts'] ? record['Bad Debts'].toFixed(2) : 0}</Button>
                    // </Tooltip>
                )
            },

        ];
        const monthDetailColumns = [
            {
                title: "University",
                dataIndex: "university",
                key: "university",
                // searchTextName: 'Currency',
                render: (text, record) => (
                    <div>{record.university}</div>
                    // <Tooltip title="Show Details">
                    //     <Button size="small" onClick={() => this.getDetailsByMonth(record.month)}>{record.month}</Button>
                    // </Tooltip>
                )
            },
            {
                title: "Earned",
                dataIndex: "total",
                key: "total",
                render: (text, record) => (
                    // <div>{record.total ? record.total.toFixed(2) : 0}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.showStudentDetails(record.universityId, null)}>{record.total ? record.total.toFixed(2) : 0}</Button>
                    </Tooltip>
                )
            },
            {
                title: "To Be Invoiced",
                dataIndex: "Pending",
                key: "Pending",
                render: (text, record) => (
                    // <div>{record.Pending ? record.Pending.toFixed(2) : 0}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.showStudentDetails(record.universityId, 'Pending')}>{record.Pending ? record.Pending.toFixed(2) : 0}</Button>
                    </Tooltip>
                )
            },
            {
                title: 'Invoiced',
                dataIndex: 'Invoiced',
                key: 'invoiced',
                render: (text, record) => (
                    // <div>{(
                    //     (record.Invoiced ? Number(record.Invoiced.toFixed(2)) : 0) +
                    //     (record.Disbursed ? Number(record.Disbursed.toFixed(2)) : 0) +
                    //     (record['Under Review'] ? Number(record['Under Review'].toFixed(2)) : 0) +
                    //     (record['Bad Debts'] ? Number(record['Bad Debts'].toFixed(2)) : 0)
                    // ).toFixed(2)}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.showStudentDetails(record.universityId, 'Invoiced')}>
                            {(
                                (record.Invoiced ? Number(record.Invoiced.toFixed(2)) : 0) +
                                (record.Disbursed ? Number(record.Disbursed.toFixed(2)) : 0) +
                                (record['Under Review'] ? Number(record['Under Review'].toFixed(2)) : 0) +
                                (record['Bad Debts'] ? Number(record['Bad Debts'].toFixed(2)) : 0)
                            ).toFixed(2)}
                        </Button>

                    </Tooltip>
                )
            },
            {
                title: 'Received',
                dataIndex: 'Disbursed',
                key: 'Disbursed',
                render: (text, record) => (
                    // <div>{record['Disbursed'] ? record['Disbursed'].toFixed(2) : 0}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.showStudentDetails(record.universityId, "Disbursed")}>{record['Disbursed'] ? record['Disbursed'].toFixed(2) : 0}</Button>
                    </Tooltip>
                )
            },
            {
                title: 'Outstanding',
                dataIndex: 'Under Review',
                key: 'Under Review',
                render: (text, record) => (
                    // <div>{record['Under Review'] ? record['Under Review'].toFixed(2) : 0}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.showStudentDetails(record.universityId, "Under Review")} >{record['Under Review'] ? record['Under Review'].toFixed(2) : 0}</Button>
                    </Tooltip>
                )
            },
            {
                title: 'Withdrawals',
                dataIndex: 'Bad Debts',
                key: 'Bad Debts',
                render: (text, record) => (
                    // <div>{record['Bad Debts'] ? record['Bad Debts'].toFixed(2) : 0}</div>
                    <Tooltip title="Show Details">
                        <Button size="small" onClick={() => this.showStudentDetails(record.universityId, "Bad Debts")}>{record['Bad Debts'] ? record['Bad Debts'].toFixed(2) : 0}</Button>
                    </Tooltip>
                )
            },
        ]


        const instituteTableColumn = [
            {
                title: `University Name ${viewByBranch ? '' : '/ Channel Partner Name'}`,
                key: 'name',
            },
            {
                title: 'Commission Amount',
                key: 'amount',
                render: (text, record) => (
                    <Tooltip title="Show Details">
                        <Button
                            size="small"
                            onClick={() => this.showStudentDetails(record.id, record.type, record.name)}
                        >
                            {currencySymbols[currency]}{text.toFixed(2)}
                        </Button>
                    </Tooltip>
                )
            }
        ]

        return (
            <PageHeaderWrapper title="Finance Wallet Report (Overall Till Date)">
                {
                    showStudentDetailDrawer ?
                        <FinanceWalletStudentDetails id={this.state.id} name={this.state.name} type={this.state.type} time={this.state.time} currency={this.state.currency} paymentStatus={this.state.paymentStatus} onClose={this.closeStudentDetail} />

                        : null
                }

                {/* <Card>
                    <Row gutter={16}>
                        <Col span={8}>
                            <h4>FILTER BY DATE</h4>
                            <RangePicker
                                format="YYYY-MM-DD"
                                placeholder={['Start Time', 'End Time']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                        <RightsWrapper myRight={"financeWalletReportExport.view"}>
                            <Col span={4}>
                                <Button type={'default'}
                                    style={{ marginTop: 20 }}
                                    onClick={() => {
                                        this.exportExcel()
                                    }}>Export Excel</Button>
                            </Col>
                        </RightsWrapper>
                    </Row>
                </Card> */}
                <div className="finance-container" style={{ padding: '20px', background: '#fff' }}>

                    {/* --- Top Section: Summary & Filters --- */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                        marginBottom: '24px',
                        paddingBottom: '20px',
                        borderBottom: '1px solid #f0f0f0'
                    }}>

                        {/* Financial Summary */}
                        <Card
                            bordered={true}
                            style={{
                                width: 'fit-content',
                                minWidth: '240px',
                                borderRadius: '8px',
                                borderLeft: '4px solid #1890ff',
                                boxShadow: 'none'
                            }}
                            bodyStyle={{ padding: '16px 20px' }}
                        >
                            <div style={{ display: 'flex', gap: '40px' }}>

                                {/* ✅ TOTAL AMOUNT */}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: '12px', textTransform: 'uppercase', color: '#8c8c8c', letterSpacing: '1px', fontWeight: 600 }}>
                                        Gross Amount Due
                                    </span>

                                    <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#262626', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                                        <span style={{ fontSize: '18px', fontWeight: '500', color: '#595959' }}>
                                            {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                                        </span>

                                        <span>
                                            {totalAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                        </span>
                                    </div>
                                </div>

                                {/* ✅ TOTAL LIABILITY */}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: '12px', textTransform: 'uppercase', color: '#8c8c8c', letterSpacing: '1px', fontWeight: 600 }}>
                                        Total Liability
                                    </span>

                                    <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#ff4d4f', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                                        <span style={{ fontSize: '18px', fontWeight: '500', color: '#595959' }}>
                                            {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                                        </span>

                                        <span>
                                            {totalLiability.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                        </span>
                                    </div>
                                </div>

                                {/* Net Amount Due */}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: '12px', textTransform: 'uppercase', color: '#8c8c8c', letterSpacing: '1px', fontWeight: 600 }}>
                                        Net Amount Due
                                    </span>

                                    <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#008000', display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                                        <span style={{ fontSize: '18px', fontWeight: '500', color: '#595959' }}>
                                            {currencySymbols[companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR']}
                                        </span>

                                        <span>
                                            {netAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </Card>

                        {/* Filter Section */}
                        <div style={{ textAlign: 'right' }}>
                            <h4 style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '8px', fontWeight: 600 }}>
                                <Icon type="calendar" style={{ marginRight: 8 }} />
                                FILTER BY DUE DATE
                            </h4>
                            <RangePicker
                                style={{ width: '300px' }}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </div>
                    </div>

                    {/* --- Table Section --- */}
                    <div className="print-table-container">
                        <TableComp
                            ref={this.table}
                            size="middle" // Makes the table look more professional for reports
                            columns={columns}
                            apiRequest={this.apiRequest}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 50,
                                pageSizeOptions: ['10', '20', '50', '100', '1000'],
                                position: 'bottom'
                            }}
                        />
                    </div>
                </div>
                {showCurrencyDetail ?
                    <Card title={<span style={{ color: "#fff" }}>{currency}</span>} className='mainCardStyle'>
                        <TableComp
                            ref={this.table1}
                            columns={currencyDetailColumns}
                            apiRequest={this.apiCurrencyDetailRequest}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 50,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>

                    : null}
                {showYearDetail && year ?
                    <Card title={<span style={{ color: "#fff" }}>{year}</span>} className='mainCardStyle'>
                        {/* <Card style={{ marginTop: 20, textAlign: 'center', color: "#fff" }} className='mainCardStyle' title={year}> */}
                        <TableComp
                            ref={this.table2}
                            columns={yearDetailColumns}
                            apiRequest={this.apiYearDetailRequest}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 50,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    : null}
                {
                    showMonthDetail && year && month ?
                        <Card title={<span style={{ color: "#fff" }}>{`${year}-${month}`}</span>} className='mainCardStyle'>

                            <TableComp
                                ref={this.table3}
                                columns={monthDetailColumns}
                                apiRequest={this.apiMonthDetailRequest}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 50,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </Card>


                        : null
                }

                {
                    this.state.showInstitutionTable && this.state.paymentStatus && this.state.currency ?
                        <Card title={<span style={{ color: "#fff" }}>{` ${this.state.paymentStatus.toUpperCase()} - ${currency}`}</span>} className='mainCardStyle'>

                            <TableComp
                                ref={this.institutionTable}
                                columns={instituteTableColumn}
                                apiRequest={this.apiShowInstituteTable}
                            />
                        </Card>
                        : null
                }
            </PageHeaderWrapper>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)(FinanceWalletReport)